import type React from 'react';

import useStyles from './SpacingContainer.styles';

type BaseSpacingContainerProps = React.JSX.IntrinsicElements['div'] & {
  children?: React.ReactNode;
};

export type SpacingContainerProps = BaseSpacingContainerProps &
  (
    | { isFeatured?: boolean; spacingLevelOverride?: never }
    | { isFeatured?: never; spacingLevelOverride: number }
    | { isFeatured?: never; spacingLevelOverride?: never }
  );

const DEFAULT_SPACING_LEVEL = 3;
const FEATURED_SPACING_LEVEL = 5;

export function SpacingContainer({
  children,
  isFeatured = false,
  className,
  spacingLevelOverride,
  ...props
}: SpacingContainerProps) {
  const spacingLevel: number = isFeatured
    ? FEATURED_SPACING_LEVEL
    : (spacingLevelOverride ?? DEFAULT_SPACING_LEVEL);

  const { classes, cx } = useStyles({ spacingLevel });
  return (
    <div
      className={cx(classes.container, className, 'style-overrides')}
      {...props}
    >
      {children}
    </div>
  );
}
